(() => {
  if (window.dcvProductPreviewLoaded) return;
  window.dcvProductPreviewLoaded = true;
  function syncColours() {
    document.querySelectorAll('[data-dcv-colours]').forEach(control => {
      const section = control.closest('.shopify-section');
      const picker = section?.querySelector('variant-picker[data-template-product-match="true"]');
      const field = picker?.querySelector('[data-dcv-option="color"], [data-dcv-option="colour"]');
      if (!field || !customElements.get('variant-picker')) return;
      const selected = field.querySelector('input:checked')?.value;
      control.querySelectorAll('[data-dcv-colour]').forEach(button => {
        const pressed = String(button.dataset.dcvColour === selected);
        if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      });
      const name = control.querySelector('[data-dcv-colour-name]');
      if (name && name.textContent !== selected) name.textContent = selected || '';
      if (control.hidden) control.hidden = false;
      if (!section.classList.contains('dcv-colours-ready')) section.classList.add('dcv-colours-ready');
    });
  }
  // The original description is retained. Only remove its duplicated size-chart preamble.
  document.querySelectorAll('[data-dcv-description]').forEach(description => {
    const first = description.firstElementChild;
    const table = description.querySelector('table');
    if (!first?.textContent.trim().startsWith('Size guide') || !table) return;
    while (description.firstElementChild && description.firstElementChild !== table) description.firstElementChild.remove();
    const explanation = table.nextElementSibling;
    table.remove();
    if (explanation?.textContent.trim().startsWith('Chest is measured flat')) explanation.remove();
  });
  document.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    if (target?.closest('[data-dcv-close-size]')) target.closest('dialog')?.close();
    const colour = target?.closest('[data-dcv-colour]');
    if (colour) {
      const section = colour.closest('.shopify-section');
      const inputs = section?.querySelectorAll('variant-picker [data-dcv-option="color"] input, variant-picker [data-dcv-option="colour"] input');
      const input = Array.from(inputs || []).find(input => input.value === colour.dataset.dcvColour);
      if (input && !input.checked) input.click();
      syncColours();
    }
    const link = target?.closest('[data-dcv-size-link], [data-dcv-disclosure-link]');
    if (link) {
      const detail = document.getElementById(link.hash.slice(1));
      if (detail instanceof HTMLDialogElement) {
        event.preventDefault();
        detail.showModal();
      } else if (detail instanceof HTMLDetailsElement) {
        event.preventDefault();
        detail.open = true;
        detail.querySelector('summary')?.focus();
        detail.scrollIntoView({block:'center',behavior:'instant'});
      }
    }
  });
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-dcv-country-select]')) return;
    if (select.form) {
      const returnTo = new URL(window.location.href);
      const variant = select.closest('.shopify-section')?.querySelector('product-form-component input[name="id"]')?.value;
      if (variant) returnTo.searchParams.set('variant', variant);
      const destination = select.form.querySelector('input[name="return_to"]');
      if (destination) destination.value = returnTo.pathname + returnTo.search;
      select.form.setAttribute('aria-busy', 'true');
      select.form.requestSubmit();
    }
  });
  // Horizon morphs the native picker on variant changes. Observe that small subtree only.
  customElements.whenDefined('variant-picker').then(() => {
    syncColours();
    document.querySelectorAll('variant-picker[data-template-product-match="true"]').forEach(picker => {
      new MutationObserver(syncColours).observe(picker,{subtree:true,childList:true,attributes:true,attributeFilter:['checked','data-current-checked']});
      picker.addEventListener('change', syncColours);
    });
  });
})();
